import React from 'react';
import { IoClose } from 'react-icons/io5';
import { ActionIcon, Modal, Text } from 'rizzui';

interface ModalFormProps {
    isOpen: boolean;
    title: string;
    children: React.ReactNode;
    onClose: () => void;
    size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

const ModalForm: React.FC<ModalFormProps> = ({ isOpen, title, children, onClose, size = 'sm' }) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size={size}
            overlayClassName='backdrop-blur'
            containerClassName='shadow-xl'
            className='z-[999] [&_.pointer-events-none]:overflow-visible'
        >
            <div className='m-auto px-5 pt-6 flex flex-col max-h-[95vh]'>
                <div className='mb-7 flex items-center justify-between flex-shrink-0'>
                    <Text className="text-xl">{title}</Text>
                    <ActionIcon size='sm' variant='text' onClick={onClose}>
                        <IoClose className='h-auto w-6' strokeWidth={1.8} />
                    </ActionIcon>
                </div>

                <div className='min-h-0 flex-1 overflow-y-auto pb-6 pr-1'>
                    {children}
                </div>
            </div>
        </Modal>
    );
};

export default ModalForm;
